MOVE.MORTGAGE.RATES.SEARCH_VIEW = (function () {
  var props,
    state = {},
    $location = $('input#locationBox'),
    $homePrice = $('input#home-price'),
    $downPayment = $('input#down-payment'),
    $downPaymentPercent = $('input#down-payment-percent'),
    $pointsSelect = $('select.js-points-filter'),
    $creditScoreSelect = $('select.js-credit-score-selector'),
    $btnEditSearch = $('.js-sort .js-edit-start'),
    $payment = MOVE.Helper.isPhone() ? $downPayment.parents('.form-group') : $downPayment.parents('li'),
    $price = MOVE.Helper.isPhone() ? $homePrice.parents('.form-group') : $homePrice.parents('li'),
    $findRate = $('.js-find-rates-button'),
    $searchFacet = $('.js-card-search-facet'),
    $pagination = $('#pagination');

  var loanTypes = [
    {value: 'All',           label: 'All'              },
    {value: '30YrFixed',     label: '30 Year Fixed'    },
    {value: '30YrFixed_FHA', label: '30 Year Fixed FHA'},
    {value: '30YrFixed_VA',  label: '30 Year Fixed VA' },
    {value: '20YrFixed',     label: '20 Year Fixed'    },
    {value: '15YrFixed',     label: '15 Year Fixed'    },
    {value: '10YrFixed',     label: '10 Year Fixed'    },
    {value: '5Arm',          label: '5/1 ARM'          },
    {value: '7Arm',          label: '7/1 ARM'          }
  ];

  var init = function (propsRef) {
    props = propsRef;
    initSelectPurposeOnMobile()
  };

  // Only if this has been indicated via loan_purpose param
  var initSelectPurposeOnMobile = function () {
    if (props.search.purpose == 'refinance' && MOVE.Helper.isPhone()) {
      mimicLocationGoButtonClick(); // Validation kickoff for recent search
    }
  }

  // Purposing render as setting DOM using props values
  // Used in cancel and hash param handling
  var render = function () {
    $('.mrtg-rates-search .js-search-errors').hide();
    $('input[name=rate-purpose][value=' + props.search.purpose + ']').prop('checked', 'checked');
    $location.val(props.search.location);
    $homePrice.val(MOVE.MORTGAGE.addDollarCommas(props.search.price));
    $downPayment.val(MOVE.MORTGAGE.addDollarCommas(props.search.down_payment.toFixed()));
    $downPaymentPercent.val(props.search.down_payment_percent.toFixed(2) + '%');
    $pointsSelect.val(props.search.pts).trigger('change');
    $creditScoreSelect.val(props.search.credit_score).trigger('change');
    $searchFacet.removeClass('edit-mode').addClass('hidden-xs').addClass('hidden-sm').addClass('hidden-md');
    $btnEditSearch.removeClass('hide').removeClass('active');
    renderLoanTypes(props.search.loan_types);
    bindLoanTypes();
  };

  var renderLoanTypes = function (selectedLoanTypes) {
    var context = $('#loan-filters');
    var content = JST['templates/mortgage/rate_table_loan_type_checkboxes']({
      loanTypesAvailable: loanTypes,
      loanTypesSelected: selectedLoanTypes,
    });
    context.html(content);
  }

  var bindLoanTypes = function() {
    $('.js-loan-filters input[type="checkbox"]').on('change', handleLoanTypeChange);
  }

  var bind = function (actions) {
    return MOVE.Helper.isPhone() ? bindMobile(actions) : bindDesktop(actions);
  };

  var bindMobile = function (actions) {
    $('.js-edit-search').on('click', showMobileSearch);
    $('.js-find-rates-button-cancel').on('click', cancelMobileSearch);

    // Mobile select purpose via tabs
    $('.js-loan-tab-purchase').on('click', function (e) {
      e.preventDefault();
      setPurchase();
    });
    $('.js-loan-tab-refinance').on('click', function (e) {
      e.preventDefault();
      setRefinance();
    });

    bindSharedControls(actions);
  };

  var bindDesktop = function (actions) {
    // Unfortunately fancy select takes a while after render
    setTimeout(() => {
      $('.js-card-search-facet .bootstrap-select').on('click', displayEditForm);
    }, 4000);

    $('.js-card-search-facet input, .js-edit-start')
      .on('click', displayEditForm)

    $('.js-edit-cancel').on('click', cancelDesktopSearch);

    // Purpose
    $('input[type=radio][name=rate-purpose]').on('change', function (e) {
      e.preventDefault();
      if (this.value === 'purchase') {
        setPurchase();
      } else if (this.value === 'refinance') {
        setRefinance();
      }
    });
    bindSharedControls(actions);
    // Display after all js initialized
    $('.mrtg-rates-search').addClass('appear');
  };

  var getMaxMin = function () {
    return state.purpose == 'purchase' ? {max: 50, min: 0} : {max: 95, min: 50};
  };

  var setPurchase = function () {
    if (state.purpose == 'purchase') return; // Already set
    state.purpose = 'purchase';
    invertDownPayment();
    $payment.find('label').html('Down Payment');
    $price.find('label').html('Home Price');
    $downPayment.val(MOVE.MORTGAGE.addDollarCommas(state.down_payment.toFixed()));
    $downPaymentPercent.val(state.down_payment_percent.toFixed(2) + '%');
  };

  var setRefinance = function () {
    if (state.purpose == 'refinance') return; // Already set
    state.purpose = 'refinance';
    invertDownPayment();
    $payment.find('label').html('Loan Amount');
    $price.find('label').html('Home Value');
    $downPayment.val(MOVE.MORTGAGE.addDollarCommas(state.down_payment.toFixed()));
    $downPaymentPercent.val(state.down_payment_percent.toFixed(2) + '%');
  };

  var invertDownPayment = function () {
    state.down_payment_percent = 100 - state.down_payment_percent;
    state.price = MOVE.MORTGAGE.removeDollarCommas($homePrice);
    state.down_payment = state.price * state.down_payment_percent / 100;
  };

  var bindSharedControls = function (actions) {
    // Location
    $location
      .on('keyup', function () {
        // For handling click on update rates issue
        state.geo_valid = false;
        $location.removeClass('input-search-error');
      })
      .on('change', function () {
        state.geo_valid = false;
        if ($(this).val() === '') {
          $location.addClass('input-error');
          $location.attr('placeholder', 'Please Enter a Location');
        } else {
          $.fn.autocomplete.newSearch({location: $(this).val()});
        }
      });
    // Price
    $homePrice
      .on("keypress", MOVE.MORTGAGE.restrictNumbersOnly)
      .on('change', function () {
        var field = $(this),
          value = MOVE.MORTGAGE.removeDollarCommas(field) || 0,
          max = 99999999,
          min = 10000;
        if (value > max) {
          value = max;
        } else if (value < min) {
          value = min;
        }
        state.price = value;
        state.down_payment = value * MOVE.MORTGAGE.removePercentage($downPaymentPercent) / 100;
        field.val(MOVE.MORTGAGE.addDollarCommas(value));
        $downPayment.val(MOVE.MORTGAGE.addDollarCommas(state.down_payment));
      });


    // Down payment
    $downPayment
      .on("keypress", MOVE.MORTGAGE.restrictNumbersOnly)
      .on('change', function () {

        var field = $(this),
            max_min = getMaxMin(),
            value = MOVE.MORTGAGE.removeDollarCommas(field) || 0,
            price = MOVE.MORTGAGE.removeDollarCommas($homePrice),
            max = max_min.max / 100 * price,
            min = max_min.min / 100 * price;

        value = boundMinMax(value, min, max);
        field.val(MOVE.MORTGAGE.addDollarCommas(value));
        state.down_payment = value;
        // Update percentage
        state.down_payment_percent = state.down_payment / MOVE.MORTGAGE.removeDollarCommas($homePrice) * 100;
        if (isNaN(state.down_payment_percent)) {
          state.down_payment_percent = 0;
        }
        $downPaymentPercent.val(state.down_payment_percent.toFixed(2) + '%');
      });

    // Down payment percent
    $downPaymentPercent
      .on("keypress", MOVE.MORTGAGE.restrictNumbersAndDecimalPointOnly)
      .on('change', function () {
        var field = $(this),
            max_min = getMaxMin(),
            value = MOVE.MORTGAGE.removePercentage(field),
            min = max_min.min,
            max = max_min.max;

        value = boundMinMax(value, min, max);
        field.val(value.toFixed(2) + '%');
        state.down_payment_percent = value;
        state.down_payment = Math.round(MOVE.MORTGAGE.removeDollarCommas($homePrice) * (value / 100));
        $downPayment.val(MOVE.MORTGAGE.addDollarCommas(state.down_payment));
      });

    // Points Select
    $pointsSelect.on('change', handlePointsChange);

    // Credit Score Select
    $creditScoreSelect.on('change', handleCreditScoreChange);

    // Find Rates
    $findRate.on('click', function () {
      if (state.geo_valid == false) {
        // If the input has been typed in, but hasn't been validated yet
        // we can give it a shot at validating before displaying no valid location
        mimicLocationGoButtonClick();
        setTimeout(function () {
          if (state.geo_valid == true) {
            search(actions);
          } else {
            if ($('.h5').html() !== 'Please include zip code for this location') {
              noLocationFound();
            }
          }
        }, 1000);
      } else {
        search(actions);
      }
    });
  };

  var boundMinMax = function (value, min, max) {
    if (value > max) {
      value = max;
    } else if (value < min || value === null || isNaN(value)) {
      value = min;
    }
    return value;
  };

  var ltv = function () {
    var percent = MOVE.MORTGAGE.removePercentage($downPaymentPercent);
    var value = state.purpose === 'purchase' ? 100 - percent : percent;

    value = Number(value.toFixed(2));
    return value;
  };

  var locationChanged = function (address, zip, city, state_code) {
    var addrs = address.split(',');
    if (addrs.length === 1){
      return;
    }
    state.zip = Array.isArray(zip) ? zip[0] : zip;
    if (state.zip === null || state.zip === undefined) {
      state.location = address
      noZipCodeFound()
    } else {
      state.location = addrs.length === 2 && state.zip !== undefined ? state.zip +', '+ address : address;
      state.state = state_code;
      state.city = city;
      state.geo_valid = true;
      $location.val(state.location);
      enableSearchButton();
    }
  };

  var noLocationFound = function () {
    $('.js-autocomplete-dropdow').slideDown("fast", function () {
      $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">Please enter a valid location</p>');
      $(this).children('.js-no-found-results').removeClass('no-show');
    });
  };

  var noZipCodeFound = function() {
    $location.addClass('input-search-error');
    $('.found-search-results').addClass('no-show')
    $('.js-autocomplete-dropdow').slideDown("fast", function () {
      $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">Please include zip code for this location</p>');
      $(this).children('.js-no-found-results').removeClass('no-show');
    });
  }

  var handleLoanTypeChange = function (e) {
    e.preventDefault();
    var value = $(this).val();
    var fields = $('#loan-filters input').serializeArray();
    var selected = _.map(fields, function (field) {
      return field.value;
    });

    state.loan_types = computeLoanTypeValues(selected, value);
    renderLoanTypes(state.loan_types);
    bindLoanTypes();
  };

  // Handling for 'All' selected
  var computeLoanTypeValues = function(values, newValue) {
    // Clear 'All' if new value is something else
    if (newValue !== 'All') {
      values = _.reject(values, function(ltype) { return ltype === 'All'; });
    }

    if (values.indexOf('All') > -1 || allLoanTypesSelected(values)) {
      return _.map(loanTypes, function(loanType) {
        return loanType.value;
      });
    } else {
      return values;
    }
  };

  var allLoanTypeValues = function() {
    return _.map(loanTypes, function(ltype) { return ltype.value; });
  };

  var allLoanTypesSelected = function(values) {
    var allValues = allLoanTypeValues();
    return JSON.stringify(allValues) === JSON.stringify(values);
  };

  var handlePointsChange = function() {
    var value = $(this).val();
    state.pts = value;
  };

  var handleCreditScoreChange = function () {
    var value = $(this).val();
    state.credit_score = value;
  };

  var cancel = function () {
    props.search.purpose === 'purchase' ? setPurchase() : setRefinance();
    render();
  };

  var search = function (actions) {
    // Set Life Time Value
    state.ltv = ltv();
    $btnEditSearch.removeClass('hide').removeClass('active');
    // Assign our state to the page props
    props.search = state;
    // Trigger search function passed in
    if (props.search.zip) {
      searchFromProps(actions);
    } else {
      // Attempt to trigger a validation step if zip not available
      mimicLocationGoButtonClick();
      setTimeout(function() { searchFromProps(actions) }, 1500);
    }

    enableLoadingSpinner();
  };

  var searchFromProps = function(actions) {
    if (props.search.loan_types.length > 0)
    {
      $btnEditSearch.removeClass('hide').removeClass('active');
      // Hide Edit mode
      $searchFacet.removeClass('edit-mode').addClass('hidden-xs').addClass('hidden-sm').addClass('hidden-md');
      $('.js-autocomplete-dropdow').hide()
      actions.searchRates();
      actions.searchTrends(props.search.state, props.search.purpose === 'refinance');
      actions.updateTrendsHeading(props.search.state);
    }
    else{
      MOVE.MORTGAGE.RATES.SEARCH_VIEW.actions
        .displayRatesSearchError('Please select one or more loan types.');
    }
  };

  var enableLoadingSpinner = function () {
    if (!MOVE.Helper.isPhone()) {
      return;
    }
    $findRate.hide('fast', function () {
      $('#rates-loading-spinner').show().css("display", "inline-block");
    });
  };

  var disableLoadingSpinner = function () {
    if (!MOVE.Helper.isPhone()) {
      return;
    }
    $('#rates-loading-spinner').hide();
    $findRate.show();
  };

  var enterEditMode = function () {
    state = _.clone(props.search);
  };

  var displayEditForm = function () {
    $('.js-search-errors').text('');
    if ($searchFacet.hasClass('edit-mode')) return;
    $searchFacet.addClass('edit-mode');
    enterEditMode();
    $('.mrtg-rates-search .card-search-facet').removeClass('hidden-xs').removeClass('hidden-sm').removeClass('hidden-md');
    $btnEditSearch.addClass('hide');
  }

  var enableSearchButton = function () {
    var label = MOVE.Helper.isPhone() ? 'Find Rates' : 'Update Rates';
    $findRate.attr('disabled', false).text(label);
  };

  var displayRatesSearchError = function (message) {
    message = message || 'Something went wrong.';
    $('.js-search-errors').text(message).show();
    setTimeout(disableLoadingSpinner, 1000);
  };

  var showMobileSearch = function (e) {
    e.preventDefault();
    disableLoadingSpinner();
    enterEditMode();
    $pagination.hide();
    $('.js-mrtg-rate-table-mobile').slideUp('fast', function () {
      $('.js-mrtg-rates-search-mobile').slideDown('fast', function () {
        $('.js-rate-loan-search-tabs').show();
        $('.mrtg-rates-provider-disclaimer').addClass('hide');
        $('.js-loan-tab-' + state.purpose).trigger('click');
        $('html, body').animate({scrollTop: 0}, 600);
      });
    });
  };

  var cancelMobileSearch = function (e) {
    e.preventDefault();
    $location.removeClass('input-search-error');
    cancel();
    disableLoadingSpinner();
    $('.js-mrtg-rates-search-mobile').hide('fast', function () {
      $('.js-mrtg-rate-table-mobile').show('fast');
      $('.js-autocomplete-dropdow').hide()
      $pagination.show();
    });
  };

  var cancelDesktopSearch = function () {
    // Hide dropdown if still open
    $location.removeClass('input-search-error');
    $('.js-autocomplete-dropdow').hide();
    cancel();
  };

  var mimicLocationGoButtonClick = function () {
    $('button.js-searchButton').click();
  };

  MOVE.MORTGAGE.RATES.SEARCH_VIEW = {
    init: init,
    render: render,
    bind: bind,
    actions: {
      locationChanged: locationChanged,
      noLocationFound: noLocationFound,
      displayRatesSearchError: displayRatesSearchError
    }
  };

  return MOVE.MORTGAGE.RATES.SEARCH_VIEW;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/views/search_view.js